/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.27",
    versionName: "0.2.0-nightly.2025.12.27",
    versionChannel: "nightly",
    buildDate: "2025-12-27T00:08:10.272Z",
    commitHash: "e4533d82426485c946966f1e225ee09036730eac",
};
